export const checkIfUserIsAllowToSelectUsersRegion = (features) => {
  const featureFound = features.find(feature => feature.name == "select_users_for_region")

  return !!featureFound
}